import { render, staticRenderFns } from "./WebTabUpdated.vue?vue&type=template&id=143d3add"
import script from "./WebTabUpdated.vue?vue&type=script&lang=js"
export * from "./WebTabUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports